//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isType, randomString } from "../../../helpers/utils";

const valuePropDef = {
    type: [String, Number, Boolean, Array],
    default: undefined,
};

function updateLocalValue(value, previousValue) {
    if (value === previousValue) {
        return;
    }
    this.localValue = value;
    // TODO: Do we want to do this to trigger event listeners?
    // inputEl.dispatchEvent(new Event('input', { bubbles: true }));
}

export default {
    name: "BowInput",
    inheritAttrs: false,

    model: {
        event: "update:modelValue",
    },

    props: {
        htmlTag: {
            default: null,
            type: String,
        },

        /**
         * Every input should have a label with the exception of `radio` which supports labels for the `options` prop.
         */
        label: {
            default: null,
            required: false,
            type: String,
        },

        labelFloated: {
            default: false,
            type: Boolean,
        },

        /**
         * Every input should have a label with the exception of `radio` which supports labels for the `options` prop.
         */
        name: {
            type: String,
            required: true,
        },

        /**
         * The input value. Works for all inputs except type `radio`. See `options` prop.
         */
        value: valuePropDef,

        modelValue: valuePropDef,

        theme: {
            default: "primary",
            type: String,
        },

        type: {
            type: String,
            default: "text",
        },

        /**
         * An array of options used for inputs of type `radio` or type `select`
         */
        options: {
            type: [Array, Object],
            default: () => [],
        },

        errors: {
            type: Object,
            default: () => ({}),
        },

        classes: {
            type: Object,
            default: () => ({}),
        },
    },

    data: () => ({
        // localValue: this.modelValue || this.value, // Required for weird bug when nested in VForm
        localValue: null,
        valid: true,
        anyInvalid: false, // TODO: deprecate
        dirty: false,
        invalid: {},
        isFocused: false,
    }),

    computed: {
        /** @returns {any} */
        bind() {
            const {
                id,
                name,
                valid,
                dirty,
                error,
                errorMessages,
                classes,
                $attrs,
            } = this;

            const { class: _, attrs } = $attrs;

            const describedby = [];

            if (error) {
                describedby.push(`${id}__description`);
            }

            if (errorMessages.length) {
                describedby.push(`${id}__errors`);
            }

            const bindings = {
                "aria-invalid": !valid,
                "aria-describedby":
                    dirty && describedby.length ? describedby.join(" ") : false,
                ...attrs,
                id: `${id}__input`,
                name,
                class: ["a-input__input", classes.input],
            };

            return bindings;
        },

        /** @returns {Record<string, string> | Record<string, Function | Function[]>} */
        listeners() {
            return this.$listeners;
        },

        slots() {
            return this.$slots;
        },

        getBorder() {
            switch (this.theme) {
                case "primary":
                    return "border-primary";

                case "secondary":
                    return "border-secondary";

                default:
                    return "border-primary";
            }
        },

        computedOptions() {
            const { $attrs, localValue, type } = this;

            let options = this.options;

            if (isType(options, "object")) {
                options = Object.entries(options).map(([key, value]) => ({
                    value: key,
                    label: value,
                }));
            }

            return options.map((item) => {
                // Each item should be an object with at least value and label which we can bind to later
                item = isType(item, "object") ? item : { value: item };
                Object.assign(item, $attrs, {
                    label: item.label || item.value,
                    value: item.value,
                });

                if (localValue !== undefined) {
                    if (type === "checkbox") {
                        item.checked =
                            localValue.includes(item.value) || item.checked;
                    } else {
                        item.checked =
                            item.value === localValue || item.checked;
                    }
                }

                return item;
            });
        },

        /** @returns {boolean} */
        error() {
            return !this.valid && this.dirty;
        },

        errorMessages() {
            const { invalid, errors, $attrs } = this;
            const errorMessages = [];
            Object.keys(errors || {}).forEach((key) => {
                if (!invalid[key]) {
                    return;
                }
                const errorHandlerOrMessage = errors[key];
                const errorMessage = isType(errorHandlerOrMessage, "function")
                    ? errorHandlerOrMessage($attrs[key])
                    : errorHandlerOrMessage;
                errorMessages.push(errorMessage);
            });
            return errorMessages;
        },

        isActive() {
            return (
                this.labelFloated === true &&
                this.type !== "checkbox" &&
                ((this.localValue && this.localValue !== "") ||
                    this.isFocused === true)
            );
        },
    },

    watch: {
        modelValue: updateLocalValue,

        value: updateLocalValue,

        localValue(value) {
            /**
             * @event update
             * @type { any }
             */
            this.$emit("update:modelValue", value);
            this.validate();
        },
    },

    created() {
        this.id = this.$attrs.id || "a-" + randomString(4);
    },

    mounted() {
        this.validate();
    },

    methods: {
        onFieldsetInput(event) {
            const input = event.target;
            const value = input.value;
            if (input.type === "radio") {
                this.localValue = value;
                return;
            }
            const newValue = [...(this.localValue || [])];
            const index = newValue.indexOf(value);
            if (index === -1) {
                newValue.push(value);
            } else {
                newValue.splice(index, 1);
            }
            this.localValue = newValue;
        },

        validate() {
            let input = this.$refs.input;
            if (Array.isArray(input)) {
                if (!input.length) {
                    return;
                }
                input = input[0];
            }
            const { validity } = input;
            // https://logaretm.com/blog/2019-05-03-html-aided-vuejs-form-validation/
            this.anyInvalid = !validity.valid; // TODO: deprecate
            this.valid = validity.valid;
            this.invalid = {
                type: validity.typeMismatch,
                required: validity.valueMissing,
                minlength: validity.tooShort,
                maxlength: validity.tooLong,
                min: validity.rangeUnderflow,
                max: validity.rangeOverflow,
                pattern: validity.patternMismatch,
            };
        },
    },
};
